import { Link } from "react-router-dom";

const LAST_UPDATED = "August 29, 2026";

const Terms = () => {
  return (
    <div className="min-h-screen w-full relative overflow-x-hidden text-white">
      <div
        className="fixed inset-0 z-[-1]"
        style={{
          backgroundImage: `url('/bg-hero.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="relative z-10 max-w-2xl mx-auto px-4 py-12 sm:py-16">
        <div className="backdrop-blur-2xl bg-black/40 border border-white/10 rounded-3xl p-6 sm:p-10 shadow-2xl">
        <h1
          className="text-3xl sm:text-4xl mb-2"
          style={{ fontFamily: "Anton, sans-serif" }}
        >
          <span className="text-[#FF0055]">TERMS</span> OF SERVICE
        </h1>
        <p className="text-[#A1A1AA] text-sm mb-10">Last updated: {LAST_UPDATED}</p>

        <div className="space-y-8 text-[#D4D4D8] leading-relaxed">
          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Agreement</h2>
            <p>
              By using Tap First at tap-first.com, you agree to these terms. If you don't agree,
              please don't use the game.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">The game</h2>
            <p>
              Tap First is a real-time buzzer game. Anyone can join a room as a guest with just a
              display name. Creating and hosting rooms requires a free account; hosting unlimited
              rooms with unlimited players requires a one-time Pro purchase.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Accounts</h2>
            <p>
              You're responsible for keeping your account credentials secure and for activity that
              happens under your account. Provide accurate information when you register, and let
              us know if you believe your account has been compromised.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Pro purchases &amp; refunds</h2>
            <p>
              Pro access is available as a Monthly plan ($6.99 USD, billed monthly, cancel anytime)
              or a Lifetime plan (one-time payment of $49 USD), processed by our payment partner,
              Gumroad. Refunds are handled according to Gumroad's standard refund policy — contact
              us at{" "}
              <a href="mailto:info@tap-first.com" className="text-[#00F0FF] hover:underline">
                info@tap-first.com
              </a>{" "}
              if you have an issue with a purchase and we'll help sort it out.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Acceptable use</h2>
            <p className="mb-2">Please don't use Tap First to:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Harass, abuse, or harm other players</li>
              <li>Use names or content that are offensive, hateful, or illegal</li>
              <li>Attempt to disrupt, hack, or overload the service</li>
              <li>Use the game for anything unlawful</li>
            </ul>
            <p className="mt-2">
              We may suspend or remove accounts or rooms that violate these rules.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Availability</h2>
            <p>
              We do our best to keep Tap First up and running, but the game is provided "as is"
              without guarantees of uninterrupted availability. We're not liable for lost data,
              interrupted games, or damages beyond the amount you've paid us, to the extent
              permitted by law.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Changes</h2>
            <p>
              We may update these terms from time to time. Continued use of Tap First after a
              change means you accept the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Contact</h2>
            <p>
              Questions about these terms? Email{" "}
              <a href="mailto:info@tap-first.com" className="text-[#00F0FF] hover:underline">
                info@tap-first.com
              </a>.
            </p>
          </section>
        </div>

        <p className="mt-12 text-center">
          <Link to="/" className="text-[#A1A1AA] hover:text-white text-sm">← Back to home</Link>
        </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
